// react and next imports
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";

// graphql imports
import { LABEL_AND_CONFIG_QUERY } from "@/graphql/settingsQuery";

// redux imports
import store from "@/redux/store";
import {
  fetchLabelsAndConfigData,
  setLabelsConfigsData,
} from "@/redux/actions/labelsAndConfigActions";

// components imports
const MetaTags = dynamic(() => import("@/common/MetaTags"));
const MainSlider = dynamic(() => import("@/components/Sliders"));
const StickyScrollBar = dynamic(() => import("@/components/StickyScrollBar"));
const IntroSectionInner = dynamic(() => import("@/components/Section/IntroSectionInner"));
const ContainerWithShadow = dynamic(() => import("@/components/Section/ContainerWithShadow"));
const Breadcrumbs = dynamic(() => import("@/components/Breadcrumbs"));

//import assets
import { WHY_CAMPING_PAGE_QUERY } from "@/graphql/whyCampingTamaro";
import { fetchWhyCampingPageData } from "@/redux/actions/whyCampingTamaroPageActions";

const Accessibility = (props) => {
  const { allWhyCampingPageData, labelsConfigData } = props;

  const dispatch = useDispatch();

  // const servicePageData = useSelector

  const [labelsList, setLabelsList] = useState({});
  const [siteConfig, setSiteConfig] = useState({});

  useEffect(() => {
    // Set labelslist local state while changed on redux store data
    dispatch(setLabelsConfigsData(labelsConfigData));
    setLabelsList(labelsConfigData?.buttonsAndLabelsPage);
    setSiteConfig(labelsConfigData?.siteConfig);
  }, [dispatch, labelsConfigData]);

  return (
    <>
      <MetaTags
        metaTags={allWhyCampingPageData?._seoMetaTags}
        seoData={allWhyCampingPageData?.seo}
        noFollow={allWhyCampingPageData?.nofollow}
        noIndex={allWhyCampingPageData?.noindex}
      />
      <StickyScrollBar />
      <div className="relative w-full">
        <MainSlider sliderData={allWhyCampingPageData?.gallery} siteConfig={siteConfig} />
      </div>
      <ContainerWithShadow containerWidthClass="container" noShadow={true}>
        <Breadcrumbs
          items={[
            {
              label: "Home",
              path: "/",
            },
            {
              label: allWhyCampingPageData?.title,
            },
          ]}
        />
        <IntroSectionInner
          title={allWhyCampingPageData?.subtitle}
          text={allWhyCampingPageData?.description}
        />
      </ContainerWithShadow>
    </>
  );
};

export default Accessibility;

export async function getStaticProps({ preview = false, locale = "en" }) {
  let query = WHY_CAMPING_PAGE_QUERY;
  // query = query?.replace(/\$slug/g, slug);
  query = query?.replace(/\lang/g, locale);

  const response = await store.dispatch(fetchWhyCampingPageData(query, preview));

  const labelsConfigData = await store.dispatch(
    fetchLabelsAndConfigData(LABEL_AND_CONFIG_QUERY, preview, { lang: locale }),
  );

  return {
    props: {
      preview,
      allWhyCampingPageData: response?.whyCampingTamaro,
      labelsConfigData: labelsConfigData || {},
    },
  };
}
